// https://github.com/mrhead/todos/blob/main/app/javascript/controllers/auto_select_controller.js

import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    connect() {
        this.element.select()
    }
}